import { useGlobalState } from '@vindr/workspace-core/contexts/GlobalContext';
import { useQueryClient } from '@tanstack/react-query';
import { useGetListReport } from '@vindr/services/actions/report.action';
import { ResponseGetOrderWorklist } from '@vindr/services/apis/order.api';
import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { queryKey } from '@vindr/services/constants/queryClientKey';
import Upload from '@vindr/workspace-core/modules/StudyFileUpload/Upload';
import PrintModal from '@vindr/workspace-core/modules/Report/Print';
import useIsMounted from '@vindr/utils/hooks/useIsMounted';
import { Modal, Typography, Button } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalQMS from '@vindr/workspace-core/modules/QMS/components/ModalQMS';
import { useGetQMSProfile } from '@vindr/services/actions/qms.action';
import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
const { Title } = Typography;

export default function OrderWorklistHeader({
  totalItem,
  selectedRowKeys,
}: {
  totalItem: number;
  selectedRowKeys: ResponseGetOrderWorklist['data'];
}) {
  const { modal, keycloak } = useGlobalState();
  const [isUploaderActive, setUploadActive] = useState(false);
  const { t } = useTranslation('Vindoc');
  const [openAddStudyModal, toggleAddStudyModal] = useState(false);
  const [isMounted] = useIsMounted();
  const queryClient = useQueryClient();
  const [openPrintDialog, setOpenPrintDialog] = useState<boolean>(false);
  const [openQMS, setOpenQMS] = useState(false);
  const qmsWorklistDefault = useGetQMSProfile({
    enabled: keycloak.hasOneOfPerm([PERMISSIONS.qms.profile])
  })?.data?.data?.qms_worklist_default;

  const canPrint = useMemo(
    () =>
      selectedRowKeys.length > 0
        ? selectedRowKeys.every((it) => it?.status === ORDER_STATUS.APPROVED)
        : false,
    [selectedRowKeys]
  );

  const reportsResponse = useGetListReport(selectedRowKeys, {
    enabled: canPrint,
  });
  const reports = reportsResponse.map((x) => x.data);
  // const isReady = reportsResponse.some((x) => x.isLoading);

  /*   const menu = (
    <Menu style={{ minWidth: 130 }}>
      <Menu.Item onClick={() => setUploadActive(true)}>{t('Dicom Data')}</Menu.Item>
      <Menu.Item onClick={() => toggleAddStudyModal(true)}>{t('Non-dicom Data')}</Menu.Item>
    </Menu>
  ); */

  return (
    <div className="flex min-h-12 shrink-0 flex-wrap items-center justify-between space-x-2 border-b border-gray-800 pb-3">
      <Title level={4} className="m-0">
        {t('Orders')}
        <span className="total-item ml-1">
          ({totalItem || 0} {t('items')})
        </span>
      </Title>
      {keycloak.hasOneOfPerm([PERMISSIONS.worklist.qms]) && <Button
        className={`batch-button flex items-center justify-center text-base`}
        size="small"
        onClick={() => setOpenQMS(true)}
        // icon={<UploadOutlined />}
        style={{ width: 90 }}
        // disabled={!keycloak.hasOneOfPerm([PERMISSIONS.studylist.upload])}
      >
        {t('QMS')}
      </Button>}
      {/* <div className="btn-group flex space-x-2">
        <HISOrderList />
      </div> */}

      {/* {/* {isUploaderActive && (
        <ImportDataModal onCancel={() => setUploadActive(false)} />
      )} */}
      <Modal
        className="vindr-modal add-study"
        title={t('Study Information')}
        open={openAddStudyModal}
        maskClosable={false}
        destroyOnClose
        zIndex={1001}
        onCancel={() => toggleAddStudyModal(false)}
        footer={null}
      >
        {/* <StudyInfoForm
          studyInfo={studyInfo}
          toggleReport={false}
          toggleConvert={keycloak.hasOneOfPerm([
            NEW_SCOPES.worklist.nondicom.convert,
          ])}
          toggleReportValue={withReport}
          toggleConvertValue={convertToDicom}
          onSave={handleSave}
          onCancel={() => toggleAddStudyModal(false)}
        /> */}
      </Modal>
      {/* <Modal
        className="vindr-modal create-study"
        title={t('Dicom Adapter')}
        width="100vw"
        style={{ top: 48 }}
        open={openDetailStudyModal}
        destroyOnClose
        maskClosable={false}
        footer={null}
        onCancel={() => {
          setStudyInfo(null);
          toggleDetailStudyModal(false);
        }}
      >
        <div
          style={{
            height: window.innerHeight < 700 ? 535 : window.innerHeight - 165,
          }}
        >
          <CreateStudy
            studyInfo={studyInfo}
            withReport={withReport}
            convertToDicom={convertToDicom}
            onStudyInfoChange={value => setStudyInfo(value)}
            onOpenEdit={() => toggleAddStudyModal(true)}
            onFinish={() => {
              toggleDetailStudyModal(false);

              //? Refresh study list when upload new NON-DICOM file
              setRefreshStudyList(new Date());
            }}
          />
        </div>
      </Modal> */}
      {isMounted && isUploaderActive && (
        <Upload
          open={isUploaderActive}
          onCancel={() => {
            setUploadActive(false);
            queryClient.invalidateQueries([queryKey.studies_interval]);
          }}
          modal={modal}
        />
      )}
      {openPrintDialog && (
        <PrintModal handleClose={() => setOpenPrintDialog(false)} reports={reports} />
      )}
      <ModalQMS
        qmsId={qmsWorklistDefault?.id}
        open={openQMS}
        type={qmsWorklistDefault?.type}
        setOpen={setOpenQMS}
      />
    </div>
  );
}
